function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function getViewportDimensions() {
  return {
    windowWidth: Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    ),
    windowHeight: Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    ),
  };
}

export function fit(el, width, height, onResize) {
  let render = dim => {
    let scale = 1;
    const { windowWidth, windowHeight } = dim;

    if (width !== windowWidth && height !== windowHeight) {
      let scaleX = windowWidth / width,
        scaleY = windowHeight / height;

      scale = windowWidth / windowHeight > width / height ? scaleY : scaleX;
    }

    el.style.transform = `scale(${scale})`;
    el.style.transformOrigin = '0 0';
    el.style.width = `${width}px`;
    el.style.height = `${height}px`;
    onResize(scale);
  };

  let handleWindowResize = debounce(() => {
    render(getViewportDimensions());
  }, 100);

  window.addEventListener('resize', handleWindowResize);

  render(getViewportDimensions());
}
